<template>
  <el-container direction="vertical">
    <slot></slot>
  </el-container>
</template>

<script>
export default {
  name: 'AppSplashLayout',
};
</script>

<style lang="sass" scoped>
.el-container
  height: 100vh
</style>
